
import { defineComponent, PropType, onBeforeMount, computed, ref } from 'vue';
import { projectStore } from '@/store/project-store';
import { thoughtStore } from '@/store/thought-store';
import ThoughtWrapper from '@/components/discuss/thought/Wrapper.vue';
import VueLoading from '@/components/general/Loading.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';
const thoughtRepository = RepositoryFactory.get('thought');

export default defineComponent({
  name: 'DiscussionEntry',
  inheritAttrs: false,
  props: {
    topic: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  components: {
    ThoughtWrapper,
    VueLoading,
  },
  setup(props, context) {
    const thoughts = computed(() => {
      const data = thoughtStore.getState().thoughts.filter(t => {
        if (props.topic.id == t.topic.id) {
          return true;
        }
      });
      return data;
    });
    //might be abit unnecessary, but supresses warning.
    onBeforeMount(() => {
      projectStore.setTopicId(props.topic.id);
      thoughtRepository.get({ projectid: props.topic.project.id, fieldset: 'all' }).then((res: any) => {
        thoughtStore.setThoughts(res.data);
      });
    });
    return {
      thoughts,
    };
  },
});
